import * as dev from './environment.dev'
import * as local from './environment.local'
import * as localAws from './environment.localAws'
import * as qa from './environment.qa'
import * as prod from './environment.prod'
import * as aws from './environment.aws'

const { REACT_APP_CONFIG } = process.env
const ENVIRONMENTS = { dev, local, localAws, qa, prod, aws }
const APP_ENVIRONMENT = ENVIRONMENTS[REACT_APP_CONFIG]

export default APP_ENVIRONMENT
